module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_3016.5599821e.png";